<template>
  <el-tree
    class="overflow-y-auto h-full"
    :data="treeData"
    highlight-current
    :expand-on-click-node="false"
    @node-click="handleNodeClick"
    :props="treeProps"
    node-key="id"
    :default-expand-all="true"
    ref="tree"
    v-loading="treeLoading"
  >
    <div slot-scope="{ data }" class="truncate">{{ data.chapter.slice(2) }} {{ data.name }}</div>
  </el-tree>
</template>

<script>
import {
  SafetyEvaluationSolutionApi,
  SafetyEvaluationIndexApi,
} from '@wiz-api/safety-evaluation-management'
import { isEmpty } from 'lodash'

const safetyEvaluationSolutionApi = new SafetyEvaluationSolutionApi()
const safetyEvaluationIndexApi = new SafetyEvaluationIndexApi()
export default {
  props: {
    id: {
      type: String,
      default: '',
    },
    status: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      treeData: [],
      treeProps: {
        children: 'childs',
      },
      treeLoading: false, // 目录树加载loading
    }
  },
  watch: {
    id: {
      immediate: true,
      handler(val) {
        if (!val) return
        if (this.status !== 0) {
          this.getPublishTreeData()
        } else {
          this.getTreeData()
        }
      },
    },
  },
  methods: {
    async getPublishTreeData() {
      this.treeProps.children = 'subs'
      this.treeLoading = true
      const [err, res] = await safetyEvaluationSolutionApi.getIndicesById(this.id)
      this.treeLoading = false
      if (!err && !isEmpty(res)) {
        this.treeData = res
        this.handleNodeClick(res[0])
        this.$nextTick(() => {
          this.$refs.tree.setCurrentKey(res[0].id)
        })
      }
    },
    async getTreeData() {
      this.treeProps.children = 'childs'
      this.treeLoading = true
      const [err, res] = await safetyEvaluationIndexApi.getTreeList()
      this.treeLoading = false
      if (!err && !isEmpty(res)) {
        this.treeData = res.filter((item) => {
          return item.id === this.id
        })
        this.handleNodeClick(this.treeData[0])
        this.$nextTick(() => {
          this.$refs.tree.setCurrentKey(this.treeData[0]?.id)
        })
      }
    },
    handleNodeClick(data) {
      this.$emit('node-click', data)
    },
  },
}
</script>

<style></style>
